/**
 * 选规格弹窗 - 待和商品规格整合
 */
import React, { useState, useCallback, useEffect, Fragment } from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { doProductMobx } from 'mobx/mall'
import { observer } from 'mobx-react'
import { showMsg } from '@utils'
import { format } from '@dt/fe-utils'
import i18n from 'i18next'
import { SelectScales } from '@pages/mall/product/component'
import { Stepper, Icon } from 'components'
import { TCheckoutType } from '@ctrls/mallController'

import './index.scss'

interface ICartProps {
  cnt?: number;
  disableScale?: boolean;
  payType: TCheckoutType;
  cartItemPk?: string;
  reject?: (data?: any) => void;
  resolve?: (data: any) => void;
}

const ScaleModal: React.FC<ICartProps> = ({ disableScale, payType = TCheckoutType.Cart, cartItemPk, reject, resolve }) => {
  const [cnt, setCnt] = useState(0)
  const [scale, setScale] = useState({ no: '', price: 0, actualPrice: 0, cnt: 0, groupBuyPrice: 0 })
  // const [isGroup, setIsGroup] = useState(false)
  const disabled = !doProductMobx.doProduct.scaleNo || scale.cnt <= 0
  const findScale = (scaleNo: string) => {
    if (scaleNo) {
      const doScale = doProductMobx.doProduct.scales.find((scale) => scale.no === scaleNo)
      if (doScale) {
        setScale(doScale as any)
      }
    }
  }
  const handleChangeCnt = useCallback((isAdd: boolean) => {
    if (doProductMobx.doProduct.scaleNo) {
      if (isAdd) {
        const { scaleNo, scales } = doProductMobx.doProduct
        const thisScale = scales.find(scale => scale.no === scaleNo)
        if (cnt >= thisScale.cnt) {
          showMsg(i18n.t('mall.outCnt'))
          doProductMobx.setCnt(thisScale.cnt)
          return
        }
      } else if (cnt <= 1) { // 至少买一个
        return
      }
      let _cnt = cnt + (isAdd ? 1 : -1)
      doProductMobx.setCnt(_cnt)
    }
  }, [cnt])
  const handleChangeScale = (data) => {
    findScale(data)
    doProductMobx.selectScale(data)
    doProductMobx.setCnt(1)
  }

  const handleConfirm = (data: any) => {
    resolve(data)
  }

  useEffect(() => {
    // cartItemPk && doProductMobx.pick({ cartItemPk })
  }, [])

  useEffect(() => {
    setCnt(doProductMobx.doProduct.cnt)
  }, [doProductMobx.doProduct.cnt])
  useEffect(() => {
    doProductMobx.doProduct && findScale(doProductMobx.doProduct.scaleNo)
  }, [])
  return (
    doProductMobx.doProduct?.no ? (
      <IonModal
        isOpen
        cssClass='mall-product-scale-modal'
        onDidDismiss={reject}
      >
        <IonHeader>
          <div className='modal-title'>{doProductMobx.doProduct.name}</div>
          <Icon name='close' onClick={reject} />
        </IonHeader>
        <IonContent>
          <div className='scale-container'>
            <SelectScales disableScale={disableScale} product={doProductMobx.doProduct} onChange={handleChangeScale} />
            <div className='scale-stepper-wrapper'>
              <div className='title space-between'>
                <span>{i18n.t('mall.productCnt')}</span>
              </div>
              <Stepper cnt={cnt} onChange={handleChangeCnt} />
            </div>
          </div>
        </IonContent>
        <IonFooter className='mall-footer-btn-wrap'>
          <div className='footer-btn'>
            {
              !doProductMobx.doProduct.scaleNo || scale.cnt <= 0 ? (
                <button className='primary-btn' disabled>
                  <div className='btn-txt'>{i18n.t('mall.scaleNotCnt')}</div>
                  {
                    payType === TCheckoutType.Group ? (
                      <div className='price-wrap' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.groupBuyPrice) }}></div>
                    ) : (
                      <div className='price-wrap'>
                        <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.actualPrice || 0) }}></span>
                        {scale.actualPrice !== scale.price ? <span className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.price) }}></span> : null}
                      </div>
                    )
                  }
                </button>
              ) : payType === TCheckoutType.Group ? (
                <Fragment key={doProductMobx.doProduct.no}>
                  <button
                    className={`primary-btn${disabled ? ' disabled' : ''} btn`}
                    onClick={() => handleConfirm({ payType: TCheckoutType.Group })}
                  >
                    <div className='btn-wrap'>
                      <div className='price-wrap' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.groupBuyPrice) }}></div>
                      <div className='btn-txt'>{i18n.t('productdetail.groupBuy')}</div>
                    </div>
                  </button>
                </Fragment>
              ) : (
                <button
                  className='primary-btn'
                  onClick={() => {
                    handleConfirm({ payType, product: doProductMobx.doProduct })
                  }}
                >
                  {i18n.t('newCart.confirm')}
                  {
                    scale.no ? (
                      <div className='price-wrap'>
                        <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.actualPrice || 0) }}></span>
                        {scale.actualPrice !== scale.price ? <span className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.price) }}></span> : null}
                      </div>
                    ) : null
                  }
                </button>
              )
            }
          </div>
        </IonFooter>
      </IonModal>
    ) : null
  )
}

export default observer(ScaleModal)
